export const iconMapper = status => {
  switch (status) {
    case 'PROCESSING':
    case 'PENDING_SIGNATURE':
    case 'PENDING_ACCEPTANCE':
      return 'clock'
    case 'SUCCESS':
    case 'ACCEPTED':
    case 'FINANCIAL_UNBALANCED_MISSING_TRANSACTION_REVERSAL':
      return 'check-circle'
    case 'ERROR':
    case 'PENDING_CHALLENGE_RESPONSE':
      return 'error'
    case 'TIMEOUT':
    case 'EXPIRED':
      return 'alert-folder'
    case 'REJECTED':
      return 'rejected'
    case 'REVERSED':
    case 'PARTIAL_REVERSED':
      return 'warning'
  }
}

export const iconColorMapper = status => {
  switch (status) {
    case 'PROCESSING':
    case 'PENDING_SIGNATURE':
    case 'PENDING_ACCEPTANCE':
      return 'warning' // warning
    case 'SUCCESS':
    case 'ACCEPTED':
    case 'FINANCIAL_UNBALANCED_MISSING_TRANSACTION_REVERSAL':
      return 'positive' // accepted
    case 'ERROR':
    case 'PENDING_CHALLENGE_RESPONSE':
    case 'REJECTED':
    case 'REVERSED':
    case 'PARTIAL_REVERSED':
      return 'negative' // block
    case 'EXPIRED':
    case 'TIMEOUT':
      return 'secondary' // expired
  }
}

export const colorStatusMapperModal = status => {
  switch (status) {
    case 'PROCESSING':
      case 'PENDING_SIGNATURE':
      case 'PENDING_ACCEPTANCE':
        return 'var(--warning)' // warning
      case 'SUCCESS':
      case 'ACCEPTED':
      case 'FINANCIAL_UNBALANCED_MISSING_TRANSACTION_REVERSAL':
        return 'var(--positive)' // accepted
      case 'ERROR':
      case 'PENDING_CHALLENGE_RESPONSE':
      case 'REJECTED':
      case 'REVERSED':
      case 'PARTIAL_REVERSED':
        return 'var(--negative)' // block
      case 'EXPIRED':
      case 'TIMEOUT':
        return 'var(--secondary)' // expired
  }
}
